<template>
  <div
    id="kt_modal_condicao_editar"
    ref="kt_modal_condicao_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.idCondicao === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Condição
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Condição
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.$emit('cancelarCondicao', false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div class="col-lg-2 fv-row mb-4">
              <label class="form-label">Código</label>
              <input
                id="txtCodigo"
                type="text"
                class="form-control mb-2"
                v-model="data.id"
                disabled
              />
            </div>
            <div class="col-lg-6 fv-row mb-4">
              <label class="required form-label">Descrição</label>
              <input
                :id="`txtDescricaoCondicao`"
                type="text"
                class="form-control mb-2"
                placeholder="Descrição da condição"
                maxlength="40"
                v-model="data.descricao"
                @keydown.stop.prevent.enter="nextFocus(`txtCondicoes`)"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["descricao"] }}
              </div>
            </div>
            <div class="col-lg-2 fv-row mb-4">
              <label class="form-label">Desconto</label>
              <CurrencyInput
                class="form-control mb-2 text-danger"
                placeholder="Desconto"
                style="text-align: right"
                v-model="this.data.desconto"
                :options="options"
              ></CurrencyInput>
            </div>
            <div class="col-lg-2 fv-row mb-4">
              <label class="form-label">Acréscimo</label>
              <CurrencyInput
                class="form-control mb-2 text-primary"
                placeholder="Acréscimo"
                style="text-align: right"
                v-model="this.data.acrescimo"
                :options="options"
              ></CurrencyInput>
            </div>
          </div>
          <div class="row">
            <div class="col-12 fv-row mb-4">
              <label class="required form-label">Condições</label>
              <input
                :id="`txtCondicoes`"
                type="text"
                class="form-control mb-2"
                placeholder="030/060/090"
                maxlength="300"
                v-model="data.condicoes"
                v-mask="[
                  '###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/###/',
                ]"
                @keydown.stop.prevent.enter="nextFocus(`btnConfirmarCondicao`)"
              />
              <div class="row">
                <div class="col-6 pe-0">
                  <div
                    class="fv-plugins-message-container invalid-feedback m-0"
                  >
                    {{ errosValidacao["condicoes"] }}
                  </div>
                </div>
                <div class="col-6 ps-2">
                  <div class="text-end text-muted fs-7">Ex: 030/060/090</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.$emit('cancelarCondicao', false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            :id="`btnConfirmarCondicao`"
            @click="confirmarCondicao()"
            v-bind:data-kt-indicator="this.loadingCondicao ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loadingCondicao">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import CurrencyInput from "@/components/text/CurrencyInput";
const toast = useToast();

export default {
  emits: ["cancelarCondicao", "confirmarCondicao"],
  components: { CurrencyInput },
  props: {
    idCondicao: { type: Number, required: true },
    condicao: { type: Object, required: false },
  },
  methods: {
    async confirmarCondicao() {
      var ajustaCondicoes = "";
      var condicoes = this.data.condicoes.split("/");
      for (var prop in condicoes) {
        if (condicoes[prop].trim() != "") {
          ajustaCondicoes += condicoes[prop].toString().padStart(3, "0") + "/";
        }
      }
      this.data.condicoes = ajustaCondicoes;
      this.errosValidacao = [];
      this.loadingCondicao = true;
      if (this.idCondicao === 0) {
        this.data.guid = this.$utils.generateUuidv4();
        try {
          var ret = await this.$store.dispatch(
            "condicao/postCondicao",
            this.data
          );
          if (ret.Success === true) {
            toast.success("Condição cadastrada com sucesso!", {
              timeout: 3000,
            });
            this.$emit("confirmarCondicao");
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "condicao/putCondicao",
            this.data
          );
          if (retPut.Success === true) {
            toast.success("Condição alterada com sucesso!", { timeout: 3000 });
            this.$emit("confirmarCondicao");
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      }
      this.loadingCondicao = false;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    this.errosValidacao = [];
    if (this.idCondicao === 0) {
      this.data = {
        id: 0,
        descricao: "",
        condicoes: "",
        desconto: 0,
        acrescimo: 0,
        guid: "",
      };
    } else {
      this.data = {
        id: this.condicao.id,
        descricao: this.condicao.descricao,
        condicoes: this.condicao.condicoes,
        desconto: this.condicao.desconto,
        acrescimo: this.condicao.acrescimo,
        guid: this.condicao.guid,
      };
    }

    this.$utils.requestFocus(`txtDescricaoCondicao`);
  },
  data() {
    return {
      errosValidacao: [],
      loadingCondicao: false,
      data: {
        id: 0,
        descricao: "",
        condicoes: "",
        desconto: 0,
        acrescimo: 0,
        guid: "",
      },
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
